import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-duration-field" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]

import {ref, Ref, watch, computed, inject, ComputedRef} from 'vue';
    import {useVuelidate} from '@vuelidate/core';
    import {required, minValue} from '@vuelidate/validators';
    import {Vue3MqResource} from '@/common/types/vue3mq';

    
    export enum ProjectDurationUnit {
        DAYS = 'DAYS',
        WEEKS = 'WEEKS',
        MONTHS = 'MONTHS',
    }

interface ProjectDurationModel {
        value?: number;
        unit?: ProjectDurationUnit;
        fixed?: boolean;
    }

    interface PropsProjectDuration {
        modelValue?: ProjectDurationModel | null;
        label?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDurationField',
  props: {
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const mq: Vue3MqResource | undefined = inject<Vue3MqResource>('mq');
    const isMobile: ComputedRef<boolean> = computed(() => !!mq?.mdMinus);

    const emits = __emit;

    function emitProjectDuration() {
        emits('update:modelValue', {
            value: (selectedDuration.value && parseInt(`${selectedDuration.value}`)) || undefined,
            unit: selectedUnit.value,
            fixed: selectedFixedDuration.value,
        });
    }

    const props = __props;

    const selectedDuration: Ref<number> = ref(props.modelValue?.value || 1);
    const selectedFixedDuration: Ref<boolean> = ref(props.modelValue?.fixed || false);
    const selectedUnit: Ref<ProjectDurationUnit> = ref(props.modelValue?.unit || ProjectDurationUnit.WEEKS);
    const MIN_DURATION = 1;

    const rules = computed(() => ({
        selectedDuration: {
            required,
            minValueValue: minValue(MIN_DURATION),
        },
    }));
    const v$ = useVuelidate(
        rules,
        {
            selectedDuration,
        },
        {$autoDirty: true},
    );

    function handleFilter(event: ProjectDurationUnit): void {
        selectedUnit.value = event;
    }

    watch([selectedDuration, selectedFixedDuration, selectedUnit], emitProjectDuration, {immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoyInput = _resolveComponent("VJoyInput")!
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyFilterBarButton = _resolveComponent("VJoyFilterBarButton")!
  const _component_VJoyFilterBar = _resolveComponent("VJoyFilterBar")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_VJoyCheckbox = _resolveComponent("VJoyCheckbox")!
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyTooltip = _resolveComponent("VJoyTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VJoyLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label || _ctx.$msg('client.project.component.project.duration.label')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_VJoyWrapper, {
      align: "center",
      "no-margin": "",
      "column-gap": "8"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          "no-margin": "",
          wrap: "nowrap",
          "column-gap": "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VJoyInput, {
              modelValue: selectedDuration.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDuration).value = $event)),
              name: "project-duration",
              class: "project-duration-field__duration-input",
              type: "number",
              min: MIN_DURATION,
              invalid: _unref(v$).selectedDuration.$invalid,
              required: "",
              "data-testid": "project-duration"
            }, null, 8, ["modelValue", "invalid"]),
            (isMobile.value)
              ? (_openBlock(), _createBlock(_component_VJoySelect, {
                  key: 0,
                  modelValue: selectedUnit.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedUnit).value = $event)),
                  class: "project-duration-field__unit"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("option", {
                      value: ProjectDurationUnit.DAYS
                    }, _toDisplayString(_ctx.$msg('client.project.component.project.duration.unit.DAYS')), 9, _hoisted_2),
                    _createElementVNode("option", {
                      value: ProjectDurationUnit.WEEKS
                    }, _toDisplayString(_ctx.$msg('client.project.component.project.duration.unit.WEEKS')), 9, _hoisted_3),
                    _createElementVNode("option", {
                      value: ProjectDurationUnit.MONTHS
                    }, _toDisplayString(_ctx.$msg('client.project.component.project.duration.unit.MONTHS')), 9, _hoisted_4)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_component_VJoyFilterBar, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VJoyFilterBarButton, {
                      modelValue: selectedUnit.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedUnit).value = $event)),
                      active: selectedUnit.value === ProjectDurationUnit.DAYS,
                      value: ProjectDurationUnit.DAYS,
                      "data-testid": "selected-unit-DAYS",
                      onFilter: handleFilter as () => ProjectDurationUnit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.project.duration.unit.DAYS')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "active", "value", "onFilter"]),
                    _createVNode(_component_VJoyFilterBarButton, {
                      modelValue: selectedUnit.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedUnit).value = $event)),
                      active: selectedUnit.value === ProjectDurationUnit.WEEKS,
                      value: ProjectDurationUnit.WEEKS,
                      "data-testid": "selected-unit-WEEKS",
                      onFilter: handleFilter as () => ProjectDurationUnit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.project.duration.unit.WEEKS')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "active", "value", "onFilter"]),
                    _createVNode(_component_VJoyFilterBarButton, {
                      modelValue: selectedUnit.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedUnit).value = $event)),
                      active: selectedUnit.value === ProjectDurationUnit.MONTHS,
                      value: ProjectDurationUnit.MONTHS,
                      "data-testid": "selected-unit-MONTHS",
                      onFilter: handleFilter as () => ProjectDurationUnit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.project.duration.unit.MONTHS')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "active", "value", "onFilter"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_VJoyWrapper, {
          "no-margin": "",
          wrap: "nowrap",
          "column-gap": "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VJoyCheckbox, {
              checked: selectedFixedDuration.value,
              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((selectedFixedDuration).value = $event)),
              label: _ctx.$msg('client.project.component.project.duration.fixed.label'),
              class: "project-duration-field__fixed-checkbox",
              "data-testid": "selectedFixedDuration"
            }, null, 8, ["checked", "label"]),
            _createVNode(_component_VJoyTooltip, {
              text: _ctx.$msg('client.project.component.project.duration.fixed.tooltip')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VJoyButton, {
                  circle: "",
                  icon: "info-circle",
                  variant: "ghost",
                  size: "small"
                })
              ]),
              _: 1
            }, 8, ["text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})